var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2206"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2205",
    transform: "translate(-4221 -3239)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 37",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(4221 3239)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9 21.575h6.5a14.3 14.3 0 0 0-1.33-4.3 13.086 13.086 0 0 0-2.47-3.491A19.377 19.377 0 0 0 7.753 17.4a12.929 12.929 0 0 0-.855 4.18zm25.7 0h6.5a12.929 12.929 0 0 0-.855-4.18 19.377 19.377 0 0 0-1.853-3.61 12.793 12.793 0 0 0-2.541 3.563 14.731 14.731 0 0 0-1.259 4.228zM9.605 32.168a12.922 12.922 0 0 0 2.541-3.539 14.427 14.427 0 0 0 1.259-4.2H6.9a12.7 12.7 0 0 0 .855 4.156 19.665 19.665 0 0 0 1.85 3.583zm26.79 0a19.665 19.665 0 0 0 1.853-3.586 12.7 12.7 0 0 0 .855-4.156h-6.508a14.427 14.427 0 0 0 1.259 4.2 12.921 12.921 0 0 0 2.546 3.542zM16.3 21.575h5.272V6.9a17.5 17.5 0 0 0-5.486 1.52 16.546 16.546 0 0 0-4.581 3.18 16.367 16.367 0 0 1 3.183 4.512 17.86 17.86 0 0 1 1.612 5.463zm8.122 0H29.7a17.468 17.468 0 0 1 1.639-5.462 16.783 16.783 0 0 1 3.204-4.513 16.429 16.429 0 0 0-4.608-3.183 17.768 17.768 0 0 0-5.51-1.52zM21.575 39.1V24.425H16.3a17.588 17.588 0 0 1-1.615 5.439 16.487 16.487 0 0 1-3.182 4.489 17.707 17.707 0 0 0 4.465 3.206 16.212 16.212 0 0 0 5.6 1.544zm2.85 0a16.447 16.447 0 0 0 5.629-1.544 17.546 17.546 0 0 0 4.489-3.206 16.913 16.913 0 0 1-3.206-4.489 17.2 17.2 0 0 1-1.637-5.436h-5.275zM23 23.238zM23 42a18.5 18.5 0 0 1-7.41-1.5A18.97 18.97 0 0 1 5.5 30.41 18.5 18.5 0 0 1 4 23a18.5 18.5 0 0 1 1.5-7.41A18.97 18.97 0 0 1 15.59 5.5 18.5 18.5 0 0 1 23 4a18.5 18.5 0 0 1 7.41 1.5A18.97 18.97 0 0 1 40.5 15.59 18.5 18.5 0 0 1 42 23a18.5 18.5 0 0 1-1.5 7.41A18.97 18.97 0 0 1 30.41 40.5 18.5 18.5 0 0 1 23 42z",
    transform: "translate(4229 3247)",
    style: {
      fill: "#ff731d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSports);
export default __webpack_public_path__ + "static/media/icon-sports.a1157002.svg";
export { ForwardRef as ReactComponent };